// Getters
export const ACCESS_GROUPS = 'ACCESS_GROUPS'
export const ALERTS = 'ALERTS'
export const USER_FULL_NAME = 'USER_FULL_NAME'
export const MENU = 'MENU'
export const USER = 'USER'
export const PAGE = 'PAGE'

// Mutations
export const SET_USER = 'SET_USER'
export const ADD_ALERT = 'ADD_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'

// Actions
export const INIT_STATE = 'INIT_STATE'
export const RELEASE_STATE = 'RELEASE_STATE'
export const ALERT_SUCCESS = 'ALERT_SUCCESS'
export const ALERT_INFO = 'ALERT_INFO'
export const ALERT_WARNING = 'ALERT_WARNING'
export const ALERT_DANGER = 'ALERT_DANGER'
export const ALERT_AUTO_DISMISS = 'ALERT_AUTO_DISMISS'

export const IS_APP_JS_LOADED = 'IS_APP_JS_LOADED'
export const IS_ALLOWED = 'IS_ALLOWED'
export const SET_APP_JS_LOADED = 'SET_APP_JS_LOADED'
export const CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES = 'CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES'
export const IS_APP_LOADING = 'IS_APP_LOADING'
export const SET_PAGE = 'SET_PAGE'
export const SET_CRAR_DATA = 'SET_CRAR_DATA'
export const CRAR_DATA = 'CRAR_DATA'



// WEBPACK FOOTER //
// ./src/store/definition.js